import PropTypes from 'prop-types';
import { PillText } from '@web/atoms';
import { useShopifyOfferContext } from '../../offer/shopifyContext';

export const PromoPill = ({
  message = 'off your starter box',
  variant,
  formattedOfferAmount,
}) => {
  const { formattedAmount, type } = useShopifyOfferContext();
  if (formattedOfferAmount)
    return (
      <PillText text={`${formattedOfferAmount} ${message}`} variant={variant} />
    );
  return type === 'PERCENT_AMOUNT' && formattedAmount ? (
    <PillText text={`${formattedAmount} ${message}`} variant={variant} />
  ) : null;
};

PromoPill.displayName = 'PromoPill';
PromoPill.propTypes = {
  message: PropTypes.string,
  variant: PropTypes.string,
  formattedOfferAmount: PropTypes.string,
};
